import { connect } from 'react-redux'
import React from 'react'
import Loader from 'components/D3Loader'
import { modalActions } from 'store/modal'
import { getUserScope } from 'utils/misc'
import InstrumentPreviewPage from '../components/InstrumentPreviewPage'
import { onFetchInstrument, onFetchInstrumentEvents, schedulerActions } from '../../../modules/Instrument'
import { fetchSurvey, fetchArticle } from '../../EditSurvey/modules/Survey'
import { fetchClinro } from '../../EditClinro/modules/Clinro'
import { fetchDiary } from '../../EditDiary/modules/Diary'
import {
  hasMultiScheduleFeature,
  hasSchedulingEngineFeature,
  isVersionUatOrLive,
} from '../../../../../../../../../../../utils/studyConfigUtils'
import { buildInstrumentNameMap } from '../utils/schedulePreviewHelpers'

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const {
    loading,
    instrumentReducer,
    surveyEditor,
    clinroEditor,
    diaryEditor,
    study,
    user,
    participants,
    sites = {},
    instruments,
    participantReducer,
    visitSchedules,
  } = state
  const studyID = study.currentStudy.id
  const { studyVersionList } = study
  const { cohortMap } = participants
  const { siteSelectionList = [] } = sites

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  const instrumentID = ownProps.instrumentID ?? null
  const inDrawer = ownProps.inDrawer ?? null
  // When opening a different instrument in the drawer, Redux still holds the previous instrument
  // until the new fetch completes. Don't pass stale data - show loader until the correct instrument loads.
  // Compare IDs as strings so number vs string (e.g. 123 vs "123") from API/row don't keep data stale.
  const storeInstrumentId = instrumentReducer.instrument?.id
  const isStaleDrawerData =
    inDrawer &&
    instrumentID != null &&
    storeInstrumentId != null &&
    String(storeInstrumentId) !== String(instrumentID)
  const instrument = isStaleDrawerData ? {} : instrumentReducer.instrument
  // surveyEditor state is { survey: { questions, order, ... }, surveyErrors, ... }; pass the inner survey for preview
  const survey = isStaleDrawerData ? {} : (surveyEditor?.survey ?? surveyEditor)
  const clinro = isStaleDrawerData ? {} : clinroEditor
  const diary = isStaleDrawerData ? {} : diaryEditor

  const currentStudy = study?.currentStudy
  const resolvedStudyId = ownProps.studyID || studyID
  const userScope = getUserScope(user, resolvedStudyId)
  const nameContext = {
    instrumentNameMap: buildInstrumentNameMap(instruments?.instrumentList || instruments?.allInstruments || []),
    visitTemplates: participantReducer?.visitTemplates || [],
    studyVisitSchedule: visitSchedules?.studyVisitSchedule || [],
    isVisitCycleSupported: currentStudy?.config?.visit_support?.version > 1,
    isArmsSupported: !!currentStudy?.config?.visit_support?.arms_enabled,
  }

  return {
    loading: loading.general,
    ...instrumentReducer,
    instrument,
    confirmedSchedules: isStaleDrawerData ? [] : instrumentReducer.confirmedSchedules,
    ...surveyEditor,
    survey,
    diary,
    clinro,
    studyID: ownProps.studyID || null,
    instrumentID,
    inDrawer,
    canWrite: userScope.includes('wa'),
    cohortMap,
    siteSelectionList,
    nameContext,
    caregiverEnabled: true, // !!study.currentStudy.caregiver_enabled, // TODO: uncomment once study configuration setting for `caregiver_enabled` will be presented
    userId: user?.id,
    study: study?.currentStudy,
    isReadOnlyState,
    studyVersionID,
    hasMultiSchedule: hasMultiScheduleFeature(study?.currentStudy),
    hasSchedulingEngine: hasSchedulingEngineFeature(study?.currentStudy),
  }
}

const mapDispatchToProps = {
  onFetchInstrument: (studyID, instrumentID, version, inDrawer) =>
    onFetchInstrument(studyID, instrumentID, version, inDrawer),
  onFetchInstrumentEvents: (studyID, instrumentID, inDrawer) =>
    onFetchInstrumentEvents(studyID, instrumentID, inDrawer),
  onFetchSurvey: (studyID, instrumentID, version, inDrawer) => fetchSurvey(studyID, instrumentID, version, inDrawer),
  onFetchClinro: (studyID, instrumentID, version, inDrawer) => fetchClinro(studyID, instrumentID, version, inDrawer),
  onFetchArticle: (studyID, instrumentID, version, inDrawer) => fetchArticle(studyID, instrumentID, version, inDrawer),
  onFetchDiary: (studyID, instrumentID, version, inDrawer) => fetchDiary(studyID, instrumentID, version, inDrawer),
  loadScheduleForEdit: schedulerActions.loadScheduleForEdit,
  deleteConfirmedSchedule: schedulerActions.deleteConfirmedSchedule,
  ...modalActions,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return props.loading ? <Loader /> : <InstrumentPreviewPage {...props} />
})
